import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ResponseModel } from "src/app/models/SharedModels/response.model";
import { GenericRepository } from "src/app/repositories/generic-repository/GenericRepository";
import { ProductShedMapping } from "src/app/models/Production/ProductShedMapping";
import { IProductShedMappingRepository } from "./IProductShedMappingRepository";

@Injectable({
  providedIn: 'root'
})
export class ProductShedMappingRepository
  extends GenericRepository<ProductShedMapping>
  implements IProductShedMappingRepository {

  constructor(protected _http: HttpClient) {
    super(_http, 'api/productShedMapping', environment.urlAddress);
  }

  GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
    filterText = filterText.split('/').join('~');
    if (!filterText || filterText.trim() === "") {
      filterText = "";
    }

    return this.Get(
      'SelectAll/' + currentPage + '/' + recordsPerPage + '/' + filterText
    );
  }

  SaveRec(item: ProductShedMapping): Observable<ResponseModel> {
    return this.PostData('/SaveRec', item)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
    const url = `/NavRec/${navType}/${currentIndex}`;
    return this.GetById(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  LoadRec(Id: number): Observable<ResponseModel> {
    const url = `/GetRec/${Id}`;
    return this.GetById(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  DeleteRec(Id: number): Observable<ResponseModel> {
    const url = `/DeleteRec/${Id}`;
    return this.Delete(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  Search(name: string): Observable<ResponseModel> {
    const url = `/Search/${name}`;
    return this.GetById(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }
}